import Alert from 'react-bootstrap/Alert';
function InfoAlert(props) {
  

  return (
    <Alert variant={props.variant} style={{backgroundColor:props.color}}>
      <Alert.Heading>
        <b>{props.head}</b>
      </Alert.Heading>
      <p>
        {props.body}
      </p>
    </Alert>
  );
}

export default InfoAlert;